import { Check, Users } from "lucide-react";
import { cn } from "@/lib/utils";

export default function CrewPicker({ options, size, selected, onChange }) {
  const max = Number(size || 0);
  if (!max) return null;
  const toggle = (id) => {
    if (selected.includes(id)) onChange(selected.filter((x) => x !== id));
    else if (selected.length < max) onChange([...selected, id]);
  };
  return (
    <div className="sm:col-span-2" data-testid="crew-picker">
      <p className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-800">
        <Users className="h-4 w-4 text-[#5C241E]" />Who was on your crew?
        <span className="font-mono-num text-xs font-normal text-slate-500" data-testid="crew-picked-count">{selected.length} of {max} picked</span>
      </p>
      {options.length ? (
        <div className="flex flex-wrap gap-2">
          {options.map((o) => {
            const on = selected.includes(o.id);
            const full = !on && selected.length >= max;
            return (
              <button type="button" key={o.id} onClick={() => toggle(o.id)} disabled={full} data-testid={`crew-option-${o.id}`}
                className={cn("inline-flex h-11 items-center gap-1.5 rounded-full border px-4 text-sm font-semibold transition-colors",
                  on ? "border-[#5C241E] bg-[#5C241E] text-white" : "border-border bg-white text-slate-800 hover:border-[#5C241E]",
                  full && "opacity-40")}>
                {on && <Check className="h-4 w-4" />}{o.name}
              </button>
            );
          })}
        </div>
      ) : <p className="text-xs text-slate-500">No other employees have been added yet.</p>}
    </div>
  );
}
